<template>
  <div>
    <div v-if="showIndex">
      <div class="title">VDCI Data Forms</div>
      <div class="categories-container">
        <data-category-button
          v-for="(category, i) in categories"
          :name="category.name"
          :image="category.image"
          :to="category.to"
          :key="i"
        >
        </data-category-button>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import dataCategoryButton from '../common/data-category-button.vue';
export default {
  components: { dataCategoryButton },

  computed: {
    showIndex() {
      return this.$route.path === '/data';
    },
    categories: () => [
      {
        name: 'Trap Site Masters',
        image: require('@/assets/img/data/trap-master.svg'),
        to: 'data-trap-sites',
      },
      {
        name: 'Mosquito Surveillance',
        image: require('@/assets/img/data/mosquito-surveillance.svg'),
        to: 'data-adult-surveillances',
      },
      {
        name: 'Larval Site Masters',
        image: require('@/assets/img/data/larval-master.svg'),
        to: 'data-larval-sites',
      },
      {
        name: 'Larvicide',
        image: require('@/assets/img/data/larvicide.svg'),
        to: 'data-larvicide',
      },
      {
        name: 'Adulticide',
        image: require('@/assets/img/data/adulticide.svg'),
        to: 'data-adulticide',
      },
      {
        name: 'Arbovirus',
        image: require('@/assets/img/data/arbovirus.svg'),
        to: 'data-arboviral',
      },
      {
        name: 'Larval Identification',
        image: require('@/assets/img/data/larval-identification.svg'),
        to: 'data-larval-identification',
      },
      {
        name: 'Landing Rate',
        image: require('@/assets/img/data/landing-rate.svg'),
        to: 'data-landing-rates',
      },
      {
        name: 'No Spray List',
        image: require('@/assets/img/data/no-spray-list.svg'),
        to: 'data-no-spray',
      },
      {
        name: 'Service Request',
        image: require('@/assets/img/data/service-request.svg'),
        to: 'data-service-requests',
      },
      {
        name: 'Sites',
        image: require('@/assets/img/data/sites.svg'),
        to: 'data-sites',
      },
    ],
  },
};
</script>

<style lang="scss" scoped>
.title {
  margin: 1rem;
  font-family: Roboto;
  font-size: 24px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #25345c;
}

.categories-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>
